module.exports = __webpack_public_path__ + "static/media/lion.97897712.jpg";